import React from "react";
import ESPFieldValues from "./ESPFieldValues";
import ESPIntegration from "./ESPIntegration";

function ESPCurrentIntegration() {
  return (
    <>
      <ESPIntegration />
      <ESPFieldValues />
    </>
  );
}

export default React.memo(ESPCurrentIntegration);
